import { useState } from "react";
import { T } from "../../config/theme.js";
import { Btn } from "../ui/index.jsx";

function LegalPage({ title, onBack, children }) {
  return (
    <div style={{ maxWidth: 720, margin: "0 auto", padding: "40px 20px" }}>
      <Btn variant="ghost" onClick={onBack} style={{ marginBottom: 24 }}>← 돌아가기</Btn>
      <h1 style={{ fontSize: 28, fontWeight: 800, marginBottom: 32, color: T.text }}>{title}</h1>
      <div style={{ fontSize: 14, color: T.textDim, lineHeight: 2 }}>{children}</div>
    </div>
  );
}

export function TermsPage({ onBack }) {
  return (
    <LegalPage title="이용약관" onBack={onBack}>
      <section style={{ marginBottom: 32 }}>
        <h3 style={{ fontSize: 16, fontWeight: 700, color: T.text, marginBottom: 12 }}>제1조 (목적)</h3>
        <p>이 약관은 Pause(이하 "서비스")가 제공하는 투자 행동 관리 도구 서비스의 이용과 관련하여 서비스와 이용자 간의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다.</p>
      </section>
      <section style={{ marginBottom: 32 }}>
        <h3 style={{ fontSize: 16, fontWeight: 700, color: T.text, marginBottom: 12 }}>제2조 (정의)</h3>
        <p>① "서비스"란 Pause가 제공하는 투자 원칙 비교, 데이터 상태 태그, 데이터 요약 챗봇, 리포트 생성 등의 온라인 서비스를 의미합니다.</p>
        <p>② "이용자"란 이 약관에 따라 서비스를 이용하는 자를 말합니다.</p>
        <p>③ "유료 서비스"란 Starter, Core, Pro 등 월 구독 요금을 지불하고 이용하는 서비스를 말합니다.</p>
      </section>
      <section style={{ marginBottom: 32 }}>
        <h3 style={{ fontSize: 16, fontWeight: 700, color: T.text, marginBottom: 12 }}>제3조 (서비스의 성격)</h3>
        <p style={{ background: T.yellow + "15", padding: "14px 18px", borderRadius: 10, border: `1px solid ${T.yellow}30`, color: T.text, fontWeight: 600 }}>
          ⚠️ Pause는 「자본시장과 금융투자업에 관한 법률」상 투자자문업이나 투자일임업에 해당하지 않으며, 특정 종목의 매수·매도·보유·비중·가격·시기에 관한 자문을 제공하지 않습니다. 본 서비스는 사용자가 설정한 기준과 공개 데이터를 비교·정리하는 기록 및 점검 도구입니다. 제공되는 정보는 투자판단의 참고자료가 아닌 데이터 요약 및 사용자 입력 기준 대비 비교 결과이며, 최종 투자 결정과 그에 따른 결과의 책임은 이용자 본인에게 있습니다.
        </p>
        <div style={{ marginTop: 16, fontSize: 13, color: T.textDim, lineHeight: 2 }}>
          <p>① 서비스는 금융투자상품의 취득·처분·가격·시기 등에 관한 판단을 제시하지 않습니다.</p>
          <p>② 서비스의 상태 태그는 행동 지시가 아닌 객관적 데이터 상태 표시입니다.</p>
          <p>③ AI 챗봇은 공시·재무·뉴스·가격 등 공개 데이터의 요약과 설명에 한정되며, 매수·매도·비중·시기에 관한 질문에는 응답하지 않습니다.</p>
          <p>④ 유료 기능은 투자 정보 제공의 대가가 아닌, 기록 관리·알림 자동화·UI 편의성에 대한 대가입니다.</p>
          <p>⑤ 사용자는 서비스의 챗봇·문의 기능을 매매조언이나 개별 투자판단 상담 용도로 이용할 수 없습니다.</p>
        </div>
      </section>
      <section style={{ marginBottom: 32 }}>
        <h3 style={{ fontSize: 16, fontWeight: 700, color: T.text, marginBottom: 12 }}>제4조 (이용 계약의 성립)</h3>
        <p>① 이용 계약은 이용자가 약관의 내용에 동의한 후 회원가입을 완료하면 성립됩니다.</p>
        <p>② 서비스는 다음 각 호에 해당하는 경우 가입을 거절할 수 있습니다.</p>
        <p style={{ paddingLeft: 16 }}>1. 타인의 정보를 이용한 경우</p>
        <p style={{ paddingLeft: 16 }}>2. 허위 정보를 기재한 경우</p>
        <p style={{ paddingLeft: 16 }}>3. 만 19세 미만인 경우</p>
      </section>
      <section style={{ marginBottom: 32 }}>
        <h3 style={{ fontSize: 16, fontWeight: 700, color: T.text, marginBottom: 12 }}>제5조 (유료 서비스 및 결제)</h3>
        <p>① 유료 서비스는 월 단위 구독 방식으로 제공되며, 결제일 기준 30일간 이용 가능합니다.</p>
        <p>② 구독 해지는 언제든 가능하며, 해지 시 남은 구독 기간까지 서비스를 이용할 수 있습니다.</p>
        <p>③ 환불은 「전자상거래법」 및 관련 법령에 따라 처리됩니다.</p>
      </section>
      <section style={{ marginBottom: 32 }}>
        <h3 style={{ fontSize: 16, fontWeight: 700, color: T.text, marginBottom: 12 }}>제6조 (서비스 제공 및 변경)</h3>
        <p>① 서비스는 연중무휴 24시간 제공을 원칙으로 하나, 시스템 점검 등의 사유로 일시 중단될 수 있습니다.</p>
        <p>② 리포트는 평일 오전(08:45)과 오후(16:40)에 자동 생성되며, 시장 상황에 따라 생성 시간이 변동될 수 있습니다.</p>
      </section>
      <section style={{ marginBottom: 32 }}>
        <h3 style={{ fontSize: 16, fontWeight: 700, color: T.text, marginBottom: 12 }}>제7조 (이용자의 의무)</h3>
        <p>이용자는 다음 행위를 하여서는 안 됩니다.</p>
        <p style={{ paddingLeft: 16 }}>1. 서비스 정보를 상업적으로 재배포하는 행위</p>
        <p style={{ paddingLeft: 16 }}>2. 서비스의 운영을 방해하는 행위</p>
        <p style={{ paddingLeft: 16 }}>3. 다른 이용자의 정보를 부정 수집하는 행위</p>
        <p style={{ paddingLeft: 16 }}>4. Pause의 데이터 요약 결과를 투자 자문으로 재가공하여 유포하는 행위</p>
      </section>
      <section style={{ marginBottom: 32 }}>
        <h3 style={{ fontSize: 16, fontWeight: 700, color: T.text, marginBottom: 12 }}>제8조 (면책 조항)</h3>
        <p>① 서비스는 데이터 수집 오류, 시스템 장애, 시장 급변 등으로 인해 분석 결과의 정확성을 100% 보장하지 않습니다.</p>
        <p>② 이용자가 서비스 정보를 참고하여 투자한 결과에 대해 서비스는 어떠한 책임도 지지 않습니다.</p>
        <p>③ 천재지변, 전쟁, 사이버 공격 등 불가항력 사유로 서비스를 제공할 수 없는 경우 책임이 면제됩니다.</p>
      </section>
      <section>
        <h3 style={{ fontSize: 16, fontWeight: 700, color: T.text, marginBottom: 12 }}>부칙</h3>
        <p>본 약관은 2026년 2월 18일부터 시행합니다.</p>
      </section>
    </LegalPage>
  );
}

export function PrivacyPage({ onBack }) {
  return (
    <LegalPage title="개인정보처리방침" onBack={onBack}>
      <section style={{ marginBottom: 32 }}>
        <h3 style={{ fontSize: 16, fontWeight: 700, color: T.text, marginBottom: 12 }}>1. 수집하는 개인정보 항목</h3>
        <div style={{ background: T.bg, padding: 16, borderRadius: 10, border: `1px solid ${T.border}` }}>
          <p style={{ marginBottom: 8 }}><strong style={{ color: T.text }}>필수 항목:</strong> 이메일 주소, 소셜 로그인 식별자 (Google/Kakao)</p>
          <p style={{ marginBottom: 8 }}><strong style={{ color: T.text }}>서비스 이용 시 자동 수집:</strong> 보유 종목 정보, 투자 행동 기록, Q&A 대화 내역, 서비스 이용 로그</p>
          <p><strong style={{ color: T.text }}>결제 시:</strong> 결제 정보는 PG사(토스페이먼츠)가 직접 처리하며, Pause는 결제 정보를 저장하지 않습니다.</p>
        </div>
      </section>
      <section style={{ marginBottom: 32 }}>
        <h3 style={{ fontSize: 16, fontWeight: 700, color: T.text, marginBottom: 12 }}>2. 개인정보의 수집·이용 목적</h3>
        <p>① 회원 관리: 본인 확인, 서비스 제공, 부정 이용 방지</p>
        <p>② 서비스 제공: 종목 분석 리포트 생성, AI Q&A 답변, 개인화된 투자 인사이트 제공</p>
        <p>③ 서비스 개선: 이용 통계 분석, 기능 개선, 신규 서비스 개발</p>
        <p>④ 고객 지원: 문의 응대, 공지사항 전달</p>
      </section>
      <section style={{ marginBottom: 32 }}>
        <h3 style={{ fontSize: 16, fontWeight: 700, color: T.text, marginBottom: 12 }}>3. 개인정보의 보유 및 이용 기간</h3>
        <p>① 회원 탈퇴 시 즉시 파기합니다. 단, 관련 법령에 따라 보존이 필요한 경우 해당 기간 동안 보관합니다.</p>
        <p style={{ paddingLeft: 16 }}>• 전자상거래법에 의한 계약/결제 기록: 5년</p>
        <p style={{ paddingLeft: 16 }}>• 전자금융거래법에 의한 전자금융 기록: 5년</p>
        <p style={{ paddingLeft: 16 }}>• 통신비밀보호법에 의한 로그 기록: 3개월</p>
      </section>
      <section style={{ marginBottom: 32 }}>
        <h3 style={{ fontSize: 16, fontWeight: 700, color: T.text, marginBottom: 12 }}>4. 개인정보의 제3자 제공</h3>
        <p>Pause는 원칙적으로 이용자의 개인정보를 제3자에게 제공하지 않습니다. 다만 다음의 경우 예외로 합니다.</p>
        <p style={{ paddingLeft: 16 }}>• 이용자가 사전에 동의한 경우</p>
        <p style={{ paddingLeft: 16 }}>• 법령에 의해 요구되는 경우</p>
      </section>
      <section style={{ marginBottom: 32 }}>
        <h3 style={{ fontSize: 16, fontWeight: 700, color: T.text, marginBottom: 12 }}>5. 개인정보 처리 위탁</h3>
        <div style={{ background: T.bg, padding: 16, borderRadius: 10, border: `1px solid ${T.border}` }}>
          <p style={{ marginBottom: 8 }}><strong style={{ color: T.text }}>Supabase Inc.</strong> — 회원 인증 및 데이터 저장</p>
          <p style={{ marginBottom: 8 }}><strong style={{ color: T.text }}>Anthropic</strong> — AI Q&A 답변 생성 (질문 내용 전달, 개인식별정보 미포함)</p>
          <p><strong style={{ color: T.text }}>토스페이먼츠</strong> — 결제 처리 (예정)</p>
        </div>
      </section>
      <section style={{ marginBottom: 32 }}>
        <h3 style={{ fontSize: 16, fontWeight: 700, color: T.text, marginBottom: 12 }}>6. 이용자의 권리</h3>
        <p>이용자는 언제든지 자신의 개인정보에 대해 열람, 수정, 삭제, 처리 정지를 요청할 수 있습니다. 요청은 서비스 내 "내 계정" 메뉴 또는 이메일(support@phasestock.kr)을 통해 가능합니다.</p>
      </section>
      <section style={{ marginBottom: 32 }}>
        <h3 style={{ fontSize: 16, fontWeight: 700, color: T.text, marginBottom: 12 }}>7. 개인정보 보호 조치</h3>
        <p>① 데이터 암호화: 전송 시 TLS/SSL, 저장 시 AES-256 암호화 적용</p>
        <p>② 접근 제한: JWT 토큰 기반 인증, RLS(Row Level Security) 적용</p>
        <p>③ 정기 점검: 보안 취약점 정기 검검 실시</p>
      </section>
      <section>
        <h3 style={{ fontSize: 16, fontWeight: 700, color: T.text, marginBottom: 12 }}>8. 개인정보 보호책임자</h3>
        <p>성명: 허선민</p>
        <p>이메일: support@phasestock.kr</p>
        <p style={{ marginTop: 16 }}>본 방침은 2026년 2월 18일부터 시행합니다.</p>
      </section>
    </LegalPage>
  );
}

export function DisclaimerPage({ onBack }) {
  return (
    <LegalPage title="투자 위험 고지" onBack={onBack}>
      <div style={{ background: T.red + "10", padding: 24, borderRadius: 14, border: `1px solid ${T.red}25`, marginBottom: 32 }}>
        <div style={{ fontSize: 20, fontWeight: 800, color: T.red, marginBottom: 14 }}>⚠️ 중요: 반드시 읽어주세요</div>
        <p style={{ color: T.text, fontWeight: 600, lineHeight: 2 }}>
          Pause는 투자 자문 서비스가 아닙니다. Pause에서 제공하는 모든 분석, 상태 라벨(변화 낮음/변화 발생/변동성 확대/정보 점검 필요), AI 답변은 데이터 기반의 참고 정보이며, 특정 종목의 매수·매도·보유를 추천하거나 지시하지 않습니다.
        </p>
      </div>

      <section style={{ marginBottom: 32 }}>
        <h3 style={{ fontSize: 16, fontWeight: 700, color: T.text, marginBottom: 12 }}>1. Pause의 서비스 범위</h3>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
          <div style={{ background: T.green + "10", padding: 16, borderRadius: 10, border: `1px solid ${T.green}25` }}>
            <div style={{ fontWeight: 700, color: T.green, marginBottom: 8 }}>✅ Pause가 하는 것</div>
            <p>공개 데이터 기반 종목 상태 분석</p>
            <p>미시/거시 지표 종합 정보 제공</p>
            <p>데이터 기반 AI Q&A</p>
            <p>투자 행동 기록 및 추적</p>
          </div>
          <div style={{ background: T.red + "10", padding: 16, borderRadius: 10, border: `1px solid ${T.red}25` }}>
            <div style={{ fontWeight: 700, color: T.red, marginBottom: 8 }}>❌ Pause가 안 하는 것</div>
            <p>종목 추천 (사세요/파세요)</p>
            <p>수익률 보장</p>
            <p>리딩방/시그널 서비스</p>
            <p>투자일임/자문 서비스</p>
          </div>
        </div>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h3 style={{ fontSize: 16, fontWeight: 700, color: T.text, marginBottom: 12 }}>2. 투자 위험 고지</h3>
        <p>① 주식 투자는 원금 손실의 위험이 있으며, 과거의 데이터 분석이 미래의 수익을 보장하지 않습니다.</p>
        <p>② Pause의 상태 라벨(변화 낮음/변화 발생/변동성 확대/정보 점검 필요)은 현재 시점의 데이터를 분석한 결과이며, 시장 상황에 따라 실시간으로 변동될 수 있습니다.</p>
        <p>③ AI Q&A의 답변은 제한된 데이터를 기반으로 생성되며, 오류가 포함될 수 있습니다.</p>
        <p>④ 모든 투자 결정은 이용자 본인의 판단과 책임 하에 이루어져야 합니다.</p>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h3 style={{ fontSize: 16, fontWeight: 700, color: T.text, marginBottom: 12 }}>3. 데이터 정확성</h3>
        <p>Pause는 KRX, DART, ECOS, Yahoo Finance 등 공신력 있는 데이터 소스를 활용하나, 다음의 사유로 정확성을 100% 보장하지 않습니다.</p>
        <p style={{ paddingLeft: 16 }}>• 데이터 제공처의 지연 또는 오류</p>
        <p style={{ paddingLeft: 16 }}>• 시장 급변 시 실시간 반영 지연</p>
        <p style={{ paddingLeft: 16 }}>• 시스템 점검 및 장애</p>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h3 style={{ fontSize: 16, fontWeight: 700, color: T.text, marginBottom: 12 }}>4. 관련 법령</h3>
        <p>Pause는 「자본시장과 금융투자업에 관한 법률」상 투자자문업 또는 투자일임업에 해당하지 않으며, 「전자상거래 등에서의 소비자 보호에 관한 법률」에 따른 전자상거래 서비스로 운영됩니다.</p>
      </section>

      <div style={{ background: T.bg, padding: 20, borderRadius: 12, border: `1px solid ${T.border}`, textAlign: "center" }}>
        <p style={{ fontWeight: 700, color: T.text, fontSize: 15 }}>💡 Pause는 "사세요/파세요"를 말하지 않습니다.</p>
        <p style={{ marginTop: 8 }}>"지금 이 종목은 이런 상태이니, 이것을 확인하세요"라고 안내할 뿐입니다.</p>
        <p style={{ marginTop: 4 }}>최종 투자 결정은 언제나 투자자 본인의 몫입니다.</p>
      </div>
    </LegalPage>
  );
}

export function FAQPage({ onBack }) {
  const [openIdx, setOpenIdx] = useState(null);
  const faqs = [
    { cat: "서비스 소개", q: "Pause는 어떤 서비스인가요?", a: "Pause는 내가 보유한 주식 종목의 현재 상태를 매일 분석해주는 서비스예요. 복잡한 차트와 뉴스 대신, 변화 낮음·변화 발생·변동성 확대·정보 점검 필요 4가지 상태로 한눈에 파악할 수 있어요." },
    { cat: "서비스 소개", q: "Pause는 종목 추천을 하나요?", a: "아니요. Pause는 절대로 '사세요/파세요'를 말하지 않아요. 대신 '지금 이 종목은 이런 상태이니, 이런 점을 확인하세요'라고 데이터 기반의 근거를 제공해요. 최종 투자 결정은 본인이 하는 거예요." },
    { cat: "서비스 소개", q: "분석은 얼마나 자주 업데이트되나요?", a: "평일 기준 오전 8:45과 오후 4:40에 리포트가 자동 생성돼요. 장중에도 긴급 체크(10:30, 12:00, 14:00)를 통해 급변 시 업데이트될 수 있어요." },
    { cat: "서비스 소개", q: "어떤 데이터를 분석하나요?", a: "주가·거래량·수급 등 미시 지표 9종과 KOSPI·환율·금리·VIX 등 거시 지표 6종, 그리고 DART 공시와 뉴스 이벤트까지 총 17종의 데이터를 종합 분석해요." },
    { cat: "요금제", q: "무료로도 사용할 수 있나요?", a: "네! Free 플랜으로 종목 1개의 오전 리포트를 무료로 받아볼 수 있어요. 더 많은 종목과 기능이 필요하면 유료 플랜을 이용해주세요." },
    { cat: "요금제", q: "유료 플랜의 차이가 뭔가요?", a: "Starter(₩19,000)는 전 종목 관리와 오전/오후 리포트, Core(₩49,000)는 무제한 AI Q&A와 투자 히스토리 분석, Pro(₩99,000)는 장중 긴급 알림과 적정가 분석, VaR 시뮬레이션 등 기관급 기능을 제공해요." },
    { cat: "요금제", q: "환불이 가능한가요?", a: "구독 시작 후 7일 이내에 서비스를 전혀 이용하지 않은 경우 전액 환불이 가능해요. 7일 이후에는 잔여 기간에 대한 부분 환불은 되지 않지만, 언제든 다음 결제를 취소(구독 해지)할 수 있어요." },
    { cat: "요금제", q: "얼리버드 할인이 뭔가요?", a: "베타 기간 중 가입하시면 정가 대비 50% 할인된 가격으로 이용할 수 있어요. 얼리버드 가격은 가입 시점의 가격이 계속 유지돼요." },
    { cat: "AI Q&A", q: "AI에게 어떤 질문을 할 수 있나요?", a: "'지금 추가매수 해도 돼?', '이 종목 위험한 거 아니야?', '요즘 왜 이렇게 빠져?' 같은 자연어 질문이 가능해요. AI는 실시간 데이터와 과거 대화 맥락을 기반으로 답변해요." },
    { cat: "AI Q&A", q: "AI 답변을 100% 신뢰해도 되나요?", a: "AI 답변은 데이터 기반의 참고 정보예요. 제한된 데이터와 모델의 한계로 오류가 포함될 수 있으니, 최종 판단은 본인이 하셔야 해요. Pause는 '근거'를 제공하는 거지, '정답'을 주는 게 아니에요." },
    { cat: "계정", q: "어떤 방법으로 가입할 수 있나요?", a: "현재 Google 계정으로 간편 로그인이 가능해요. 카카오 로그인도 준비 중이에요." },
    { cat: "계정", q: "계정을 탈퇴하면 데이터는 어떻게 되나요?", a: "탈퇴 시 모든 개인 데이터(보유 종목, Q&A 기록, 투자 행동 기록 등)는 즉시 삭제돼요. 단, 법령에 따라 결제 기록 등 일부 데이터는 최대 5년간 보관될 수 있어요." },
    { cat: "기타", q: "Pause에 투자할 수 있는 종목은 몇 개인가요?", a: "현재 KOSPI/KOSDAQ 주요 50개 종목을 지원하고 있어요. 지원 종목은 지속적으로 확대할 예정이에요." },
    { cat: "기타", q: "모바일에서도 사용할 수 있나요?", a: "네! Pause는 모바일 반응형으로 설계되어 스마트폰 브라우저에서도 최적화된 화면으로 이용할 수 있어요." },
  ];
  const cats = [...new Set(faqs.map(f => f.cat))];
  return (
    <LegalPage title="자주 묻는 질문 (FAQ)" onBack={onBack}>
      {cats.map(cat => (
        <div key={cat} style={{ marginBottom: 28 }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: T.accent, marginBottom: 12, textTransform: "uppercase" }}>{cat}</div>
          {faqs.filter(f => f.cat === cat).map((f, i) => {
            const globalIdx = faqs.indexOf(f);
            const isOpen = openIdx === globalIdx;
            return (
              <div key={i} style={{ marginBottom: 8, borderRadius: 10, border: `1px solid ${T.border}`, overflow: "hidden", transition: "all 0.2s" }}>
                <div onClick={() => setOpenIdx(isOpen ? null : globalIdx)} style={{ padding: "14px 18px", cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center", background: isOpen ? T.accent + "08" : T.card }}>
                  <span style={{ fontSize: 14, fontWeight: 600, color: T.text }}>{f.q}</span>
                  <span style={{ fontSize: 18, color: T.textMuted, transform: isOpen ? "rotate(45deg)" : "none", transition: "transform 0.2s" }}>+</span>
                </div>
                {isOpen && (
                  <div style={{ padding: "14px 18px", background: T.bg, fontSize: 13, color: T.textDim, lineHeight: 1.8, borderTop: `1px solid ${T.border}` }}>
                    {f.a}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      ))}
    </LegalPage>
  );
}
